<template>
    <div>
        <Head title="Звіт"/>
        <h1 class="mb-8 text-3xl font-bold">Звіт</h1>
        <div class="flex flex-col md:flex-row items-center justify-between mb-6">
            <filters-modal
                title="Замовлення"
                :params="form.params"
                :show="showModalFilter"
                :withDownloadButton="true"
                @update:form="applyFilter"
                @download="downloadOrders"
            />
        </div>
        <div class="flex flex-col md:flex-row items-center justify-between mb-6">
            <div class="flex flex-wrap p-8 bg-white rounded-md shadow overflow-hidden">
                <ul class="list-style-disk">
                    <li class="m-2">оплачено через LiqPay і не скасовано: {{ totalSumPaidNoCash }} грн</li>
                    <li class="m-2">скасовано через LiqPay: {{ totalSumNotPaid }} грн</li>
                    <li class="m-2">оплачено вручну: {{ totalSumPaidCash }} грн</li>
                    <li class="m-2">використано бонусів: {{ totalBalanceUsed }} грн</li>
                </ul>
            </div>
        </div>
        <div class="p-4 bg-white">
            <p><span class="inline-block w-4 h-4 active-calendar-item mr-2"></span> Замовлення оплачено</p>
            <p><span class="inline-block w-4 h-4 green-calendar-item mr-2"></span> Замовлення не оплачено</p>
            <p><span class="inline-block w-4 h-4 bg-teal-500 mr-2"></span> Замовлення виконано</p>
            <p><span class="inline-block w-4 h-4 bg-red-400 mr-2"></span> Замовлення скасовано</p>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6 cursor-pointer" @click.prevent="sortOrders('order.id')">
                        Номер
                        <icon
                            v-if="form.sort.sortBy === 'order.id'"
                            name="arrow"
                            :class="{'transform rotate-180': form.sort.sortOrder === 'asc'}"
                        />
                    </th>
                    <th class="pb-4 pt-6 px-6 cursor-pointer" @click.prevent="sortOrders('start_date')">
                        Дата
                        <icon
                            v-if="form.sort.sortBy === 'start_date'"
                            name="arrow"
                            :class="{'transform rotate-180': form.sort.sortOrder === 'asc'}"
                        />
                    </th>
                    <th class="pb-4 pt-6 px-6 cursor-pointer" @click.prevent="sortOrders('order.name')">
                        Ім'я
                        <icon
                            v-if="form.sort.sortBy === 'order.name'"
                            name="arrow"
                            :class="{'transform rotate-180': form.sort.sortOrder === 'asc'}"
                        />
                    </th>
                    <th class="pb-4 pt-6 px-6">Назва місця</th>
                    <th class="pb-4 pt-6 px-6">Озеро</th>
                    <th class="pb-4 pt-6 px-6">Тип</th>
                    <th class="pb-4 pt-6 px-6">Сума</th>
                    <th class="pb-4 pt-6 px-6 flex justify-center">Завершити</th>
                </tr>
                <tr v-for="order in orders.data" :key="order.id"
                    class="hover:shadow-lg focus-within:shadow-lg h-10 relative"
                    :class="[
                        {'bg-red-400' :order.is_cancel},
                        {'bg-teal-500' :order.is_done && !order.is_cancel},
                        {'active-calendar-item' : order.is_payed && !order.is_done},
                        {'green-calendar-item' : !order.is_payed && !order.is_done}
                        ]"
                >
                    <td class="border-t">
                        <Link :href="$route('table.reports.show', order.id)">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ order.liqPayId }}
                            </p>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link :href="$route('table.reports.show', order.id)">
                            <p class="flex items-center focus:text-indigo-500 cursor-pointer">
                                {{ formattedDate(order.start_date) }}
                            </p>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link :href="$route('table.reports.show', order.id)">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ order.name }}
                            </p>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link :href="$route('table.reports.show', order.id)">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ orderFishingPlace(order) }}
                            </p>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link :href="$route('table.reports.show', order.id)">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ order.lake.name }}
                            </p>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link :href="$route('table.reports.show', order.id)">
                            <p class="flex items-center focus:text-indigo-500">
                                {{ order.type?.name }}
                            </p>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link :href="$route('table.reports.show', order.id)">
                            <p class="flex items-center focus:text-indigo-500">
                                {{ order.totalSum }} грн
                            </p>
                        </Link>
                    </td>
                    <td class="border-t">
                        <checkbox
                            checkbox-class="scale-125"
                            :model-value="order.is_done"
                            class="flex justify-center"
                            @update:modelValue="value => approveOrder(value, order)"
                        />
                    </td>
                </tr>
                <tr v-if="orders.data.length === 0">
                    <td class="px-6 p-4 border-t" colspan="4">Замовлень немає</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="orders.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import FiltersModal from "@/Component/FiltersModal"
import Pagination from '@/Shared/Pagination'
import Checkbox from "@/Shared/Checkbox"

export default {
    components: {
        Checkbox,
        Head,
        Icon,
        Link,
        Pagination,
        FiltersModal
    },
    layout: Layout,
    props: {
        filters: Object,
        orders: Object,
        sort: {
            type: Object,
            default: {
                sortOrder: 'desc',
                sortBy: 'start_date'
            }
        },
        totalSumPaidNoCash: Number,
        totalSumNotPaid:    Number,
        totalSumPaidCash:   Number,
        totalBalanceUsed:   Number,
    },
    data() {
        return {
            form: {
                page: this.filters.page,
                params: this.filters.params,
                sort: this.sort,
            },
            showModalFilter: false
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.$route('table.reports'), pickBy(this.form), {
                    preserveState: true,
                    preserveScroll: true,
                })
            }, 150),
        },
    },
    methods: {
        orderFishingPlace(order) {
            if (!!order.is_point) {
                return order.point?.name ?? ''
            }
            return order.fastOrder?.name ?? ''
        },
        openModal() {
            this.showModalFilter = !this.showModalFilter;
        },
        applyFilter($event) {
            if (JSON.stringify(this.form.params) !== JSON.stringify($event)) {
                this.form.params = $event
            }
        },
        downloadOrders() {
            this.$axios({
                url: this.$route('export.orders'),
                method: 'GET',
                params: pickBy(this.form),
                responseType: 'blob',
            }).then(response => {
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'orders.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();

                document.body.removeChild(fileLink);
            }).catch(error => console.error('Download error:', error));
        },
        formattedDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('uk-UK', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        approveOrder(value, order) {
            this.$inertia.post(this.$route('order.approve', order.id), {
                status: value
            });
        },
        sortOrders(sort) {
            this.form.sort.sortBy = sort
            if (this.form.sort.sortOrder === 'asc') {
                this.form.sort.sortOrder = 'desc'
            } else {
                this.form.sort.sortOrder = 'asc'
            }
        }
    },
}
</script>
<style scoped>
:deep(.scale-125) {
    width: 20px;
    height: 20px;
}
.list-style-disk {
    list-style-type: disc;
}
</style>
